import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { faChartArea } from '@fortawesome/free-solid-svg-icons'

import PageTitle from './partials/PageTitle'
import MenuWidget from './partials/MenuWidget'

export default function MembersDashboard() {
	return (
		<React.Fragment>
			<PageTitle title="Miembros Momentos Spring" subtitle="Reportes de miembros que compran en tiendas Spring." />
			<Row>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Totales Miembros"
						subtitle="Indicadores generales Momentos"
						icon={faChartArea}
						linkTo={"/members/general_totals"}
					/>
				</Col>
				{/* <Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Segmentos por género"
						subtitle="Ver segmentos de clientes por género"
						icon={faChartArea}
						linkTo={"/customers/segment_by_gender"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Segmentos por rangos de edad"
						subtitle="Ver segmentos de clientes por rango de edad"
						icon={faChartArea}
						linkTo={"/customers/segment_by_age_range"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Segmentos por formato y género"
						subtitle="Ver segmentos de clientes por formato y género"
						icon={faChartArea}
						linkTo={"/customers/segment_by_format_and_gender"}
					/>
				</Col>
				<Col sm="12" md="6" lg="4" className="mb-10">
					<MenuWidget 
						title="Segmentos por formato y rangos de edad"
						subtitle="Ver segmentos de clientes por formato y rango de edad"
						icon={faChartArea}
						linkTo={"/customers/segment_by_format_and_age_range"}
					/>
				</Col> */}
			</Row>
		</React.Fragment>
	)
}